import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	loading: true,
	error: false,
	data: [],
	columns: [],
	deleteItem: {
		success: false,
		error: false
	},
	options: {
		pages: 0,
		page: 0,
		total_results: 0,
		startIndex: 0,
		filters: {
			query: ''
		}
	}
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH AVAILABILITY ***************
			case types.FETCH_PACKET_AVAILABILITY_TABLE_LOADING:
				draft.loading = true;
				draft.error = false;
				return;

			case types.FETCH_PACKET_AVAILABILITY_TABLE_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				draft.columns = action.payload.input.columns;
				draft.options.pages = action.payload.pages;
				draft.options.total_results = action.payload.recordsFiltered;
				draft.options.startIndex = action.payload.startIndex;
				draft.options.page = action.payload.page;
				return;

			case types.FETCH_PACKET_AVAILABILITY_TABLE_ERROR:
				draft.error = action.payload;
				return;

			// *************** DELETE AVAILABILITY ***************
			case types.DELETE_PACKET_AVAILABILITY_LOADING:
				draft.deleteItem.success = false;
				draft.deleteItem.error = false;
				return;

			case types.DELETE_PACKET_AVAILABILITY_SUCCESS:
				draft.deleteItem.success = action.payload;
				draft.deleteItem.error = false;
				return;

			case types.DELETE_PACKET_AVAILABILITY_ERROR:
				draft.deleteItem.error = action.payload;
				return;

			default:
				return state;
		}
	});
